module.exports = __webpack_public_path__ + "static/media/capitol.1ee7e65b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/developer/gallery/capitol.jpg
// module id = 170
// module chunks = 0